import lodashGet from 'lodash.get';

export const getBestValueIndex = <T>(
  list: T[],
  path: string,
  type: 'bigger' | 'smaller' = 'bigger'
): number => {
  const arrayOfItens: number[] = list
    .map((asset) => lodashGet(asset, path))
    .map((value) => transformStringInNumber(value));

  const bestValue =
    type === 'bigger' ? Math.max(...arrayOfItens) : Math.min(...arrayOfItens);

  const bestValueIndexInList = list.findIndex(
    (asset) => transformStringInNumber(lodashGet(asset, path)) === bestValue
  );

  return bestValueIndexInList;
};

const transformStringInNumber = (value: string): number => {
  if (typeof value !== 'string') return value;

  try {
    return parseFloat(value.replace(',', '.').replace('%', ''));
  } catch (error) {
    return 0;
  }
};
